import {SearchState} from './useSearch.state'

export type SearchSetters = {
  setQuery: (query: string) => void
  setFilter: (key: string, value: any) => void
  setDisplay: (key: string, value: any) => void
  setSort: (sort: string) => void
}

function useSearchSetters(
  [state, setState]: [SearchState, Function],
  fetcher: Function
): SearchSetters {
  function setQuery(query: string) {
    setState(state => ({...state, query}))
  }

  function setSort(sort: string) {
    fetcher({data: [], total: 0, sort})
  }

  function setFilter(key: string, value: any) {
    fetcher({data: [], total: 0, filters: {...state.filters, [key]: value}})
  }

  function setDisplay(key: string, value: any) {
    fetcher({display: {...state.display, [key]: value}})
  }

  return {setQuery, setFilter, setDisplay, setSort}
}

export default useSearchSetters
